/**
 * Transforms a search query based on wildcard and quote rules:
 * - If the query is enclosed in double quotes ("..."), return without the quotes (exact match)
 * - If the query already starts or ends with *, return as-is
 * - Otherwise, wrap with wildcards (*query*) for partial matching
 */
export function transformSearchQuery(query: string): string {
  const trimmedQuery = query.trim();

  if (!trimmedQuery) {
    return '';
  }

  const isQuoted = trimmedQuery.startsWith('"') && trimmedQuery.endsWith('"');
  const hasWildcard = trimmedQuery.startsWith('*') || trimmedQuery.endsWith('*');

  if (isQuoted) {
    // Remove the surrounding quotes for exact match
    return trimmedQuery.slice(1, -1);
  }

  if (hasWildcard) {
    return trimmedQuery;
  }

  return `*${trimmedQuery}*`;
}
